import React, { useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { getEntity } from './par-product-unit.reducer';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

export const ParProductUnitDetail = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getEntity(props.match.params.id));
  }, []);

  const parProductUnitEntity = useAppSelector(state => state.parProductUnit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="parProductUnitDetailsHeading">
          <Translate contentKey="almobadaraMasterDataApp.parProductUnit.detail.title">ParProductUnit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="almobadaraMasterDataApp.parProductUnit.code">Code</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="almobadaraMasterDataApp.parProductUnit.name">Name</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.name}</dd>
          <dt>
            <span id="nameAr">
              <Translate contentKey="almobadaraMasterDataApp.parProductUnit.nameAr">nameAr</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.nameAr}</dd>
          <dt>
            <span id="nameEn">
              <Translate contentKey="almobadaraMasterDataApp.parProductUnit.nameEn">nameEn</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.nameEn}</dd>
          <dt>
            <span id="status">
              <Translate contentKey="almobadaraMasterDataApp.parProductUnit.status">Status</Translate>
            </span>
          </dt>
          <dd>{parProductUnitEntity.status}</dd>
        </dl>
        <Button tag={Link} to="/par-product-unit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/par-product-unit/${parProductUnitEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ParProductUnitDetail;
